module.exports = __webpack_public_path__ + "img/8.a710fe4d.png";